<div class="title">Clustering</div>

<ng-container *ngIf="!clusteringParamsSet">
    <cds-form-group layout="vertical" class="job-selection-dialog-content">
        <cds-radio-group>
            <label>Clustering type</label>
            <cds-radio>
                <label>t-SNE</label>
                <input
                    type="radio"
                    name="tsneClustering"
                    [(ngModel)]="selectedPipeline"
                    [value]="PipelineTypeEnum.tsneClustering"
                />
            </cds-radio>
            <cds-radio>
                <label>UMAP</label>
                <input
                    type="radio"
                    name="umapClustering"
                    [(ngModel)]="selectedPipeline"
                    [value]="PipelineTypeEnum.umapClustering"
                />
            </cds-radio>
        </cds-radio-group>
    </cds-form-group>

    <ng-container *ngIf="selectedPipeline === PipelineTypeEnum.tsneClustering">
        <div class="job-selection-dialog-content">
            <app-tsne-clustering-selection
                class="default-dialog-layout"
                (paramsSet)="confirmClusteringParameters($event)"
            ></app-tsne-clustering-selection>
        </div>
    </ng-container>
    <ng-container *ngIf="selectedPipeline === PipelineTypeEnum.umapClustering">
        <div class="job-selection-dialog-content">
            <app-umap-clustering-selection
                class="default-dialog-layout"
                (paramsSet)="confirmClusteringParameters($event)"
            ></app-umap-clustering-selection>
        </div>
    </ng-container>
</ng-container>

<div class="job-selection-dialog-content">
    <ng-container *ngIf="clusteringParamsSet">
        <app-marker-clustering-selection
            class="default-dialog-layout"
            [markers$]="clusteringMarkers$"
            (selected)="selectMarkerLayers($event)"
            (abort)="abortMarkerSelection()"
        ></app-marker-clustering-selection>
    </ng-container>
</div>
